import type { UUID } from 'crypto'
import type { Nullish } from 'node_modules/@logistiek-zonder-papier/lzp-library/dist/utils/utils'

export type Project = {
  id?: UUID | Nullish
  customerId?: UUID | Nullish
  name: string
  createdAt?: Date | Nullish
  updatedAt?: Date | Nullish
  deletedAt?: Date | Nullish
}

export function createEmptyProject(): Project {
  return {
    name: '',
    id: null,
    customerId: null,
    createdAt: null,
    updatedAt: null,
    deletedAt: null,
  }
}
